export default {

  /*********************modes ******************/
   jsUcfirst(string) 
  {
      return string.charAt(0).toUpperCase() + string.slice(1);
  },

  /************Get days of the week************ */



ret_role_ecc (role) {
    var role_ =''
    switch (role) {
        case 'PA':
            role_= "pasteur";
        case 'DI':
            role_= "diacre";
          break;
        case "EV":
            role_= "Évangeliste";
          break;
          case "IT":
            role_= "intercesseur";
          break;
        case "CH":
            role_= "Chantre";
          break;
        case "PR":
            role_= "Protocole";
          break;
        case "FE":
            role_= "Femme";
          break;
          case "HO":
            role_= "Homme";
          break;
          case "JE":
            role_= "Jeune";
          break;
          case "AU":
            role_= "Aumônier";
          break;
          case "MI":
            role_= "Missionaire";
          break;
         default:
            role_= role;

            
}

return role_;
},



ret_gender (gender) {
 var gender = ""
    switch (gender) {
        case 'femme':
            gender= "F";
          break;
        case "male":
            gender= "M";
          break;
          case "homme":
            gender= "M";
          break;
         default:
            gender= gender;
      }
return gender;
}
  /*************************************************/
}


// WEBPACK FOOTER //
// ./src/api/utils.js